// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2x0Br","hidden":"_3rlCw","fullScreenControl":"_3QdAe","fullScreenToggle":"_2Y_h1","enterIcon":"_1mZMx","exitIcon":"_1IZ7N","inFullScreen":"_2O4Ev"};